export const getWaveHeight = (mobile: boolean) => {
  return mobile ? '390px' : '40%'
}
